import firehydrantAPI from 'helpers/firehydrantAPI';

import { useListQuery } from '../common/index';

export const RESOURCE_NAME = 'ticketing/projects';
export const RESOURCE = [{ resource: RESOURCE_NAME }];

export const useTicketingProjects = (params = {}) =>
  useListQuery(RESOURCE, params, () =>
    firehydrantAPI.get(RESOURCE_NAME, { params }),
  );
